import ReactMarkdown from 'react-markdown';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import './MardownRenderer.scss';
import { cn } from '@/lib/utils';

interface MarkdownRendererProps {
  content: string;
  ref?: React.RefObject<HTMLDivElement | null>;
  onScroll?: (event: React.UIEvent<HTMLDivElement>) => void;
  className?: string;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({
  content,
  ref,
  onScroll,
  className,
}) => {
  return (
    <div className={cn('markdown-renderer', className)} ref={ref} onScroll={onScroll}>
      <ReactMarkdown rehypePlugins={[[rehypeSanitize, defaultSchema]]}>{content}</ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
